<template>
  <el-dialog
    custom-class="delDictionaries"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    :show-close="showClose"
    top="35vh"
    width="480px"
    center
    @close="handleClose"
  >
    <span slot="title" class="title flex flex-j-center">
      <i class="el-icon-warning" />
      <slot name="title">{{ title }}</slot>
    </span>
    <slot name="body" />
    <slot name="footer">
      <span slot="footer" class="dialog-footer">
        <el-button v-if="!hideCancel" size="small" class="line-btn" @click="close">取 消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="submit">确 定</el-button>
      </span>
    </slot>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '删除'
    },
    showClose: {
      type: Boolean,
      default: true
    },
    hideCancel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: {},
      visible: false,
      loading: false
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    handleClose() {
      this.visible = false
    },
    cancle() {
      // 点击取消的回调
      this.$emit('cancle', () => {
        this.visible = this.loading = false
      })
    },
    close() {
      this.visible = false
      this.$emit('falseClick')
    },
    submit() {
      // 点击提交的关闭回调
      this.$emit('submit', this, () => {
        this.visible = false
        setTimeout(() => {
          this.loading = false
        }, 300)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/.delDictionaries{
    border-radius: 5px;
    .el-dialog__header{
      // padding: 24px;
      .title{
        font-weight: 600;
        font-size: 18px;
        line-height: 1;
        display: flex;
        align-items: center;
        color:#333;
        justify-content: flex-start;
        .el-icon-warning{
          color: $warn-color1;
          margin-right: 9px;
          font-size: 20px;
        }
      }
      .el-dialog__headerbtn {
        right: 32px;
        top: 32px;
        .el-icon-close {
          color: #000000;
          font-size: 20px;
          font-weight: 500;
        }
      }
    }
    .el-dialog__body{
      padding-top: 26px;
      text-align: left;
      line-height: 22px;
      font-size: 14px;
      font-weight: 400;
      color: #1D2129;
      padding-bottom: 0px;
      // padding-left: 60px;
      .el-input__count{
        line-height: 1.5;
      }
      .el-form-item{
        margin-bottom: 20px;
        &:last-child{
          margin-bottom: 0;
        }
      }
    }
    .el-dialog__footer{
      padding: 32px !important;
      display: flex;
      justify-content: flex-end;
    }
  }
</style>

